/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { MrfiktivRentalPeriodGen } from "@/services/mrfiktiv/v1/data-contracts";

@IsFilterable
class RentalPeriodBase implements MrfiktivRentalPeriodGen {
  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.rental.period.start"
  })
  start: number;

  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.rental.period.end"
  })
  end: number;

  constructor(data: MrfiktivRentalPeriodGen) {
    this.start = data.start;
    this.end = data.end;
  }
}

type IRentalPeriod = RentalPeriodBase;
const RentalPeriod = Filter.createForClass(RentalPeriodBase);

export { IRentalPeriod, RentalPeriod };
